<template>
  <div>
    <b-modal
            centered
            hide-footer
            v-model="modalShop.BankDetail" 
            size="md"
            hide-header
        >
            <div class="row">
                <div class="col-12">
                    <span class="close cursor-pointer" @click="closeModal()">&times;</span>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-lg-12 py-4">
                    <h3>{{modalShop.textHeader}}</h3> 
                </div>
            </div>
            <div class="container-fluid">
                <div class="form-group">
                  <label for="BaseSelectBank">
                    <span class="text-danger">*</span> ช่องทางรับชำระ
                  </label>
                  <BaseSelectBank 
                    :selectBanking.sync="inputBank.selectBanking" 
                    for="BaseSelectBank" 
                    ref="selectBanking"
                  />
                </div>
                <div class="form-group">
                  <label for="inputBankBanknumber">
                    <span class="text-danger">*</span> เลขที่บัญชี
                  </label>
                  <input
                      for="inputBankBanknumber"
                      v-model="inputBank.bankNumber"
                      class="form-control"
                      :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                      :class="{ 'is-invalid': submitForm && $v.inputBank.bankNumber.$error }"
                      placeholder="กรุณากรอกเลขบัญชี"
                  />
                  <label
                      v-if="submitForm && !$v.inputBank.bankNumber.required"
                      class="invalid-feedback"
                  >กรุณากรอกเลขบัญชี</label>
                  <label
                    class="error invalid-feedback"
                    v-if="!$v.inputBank.bankNumber.minLength"
                  >กรุณากรอก"เลขที่บัญชี"อย่างน้อย {{$v.inputBank.bankNumber.$params.minLength.min}} ตัวเลข</label>
                  <label
                    class="error invalid-feedback"
                    v-if="!$v.inputBank.bankNumber.maxLength"
                  >กรุณากรอก"เลขที่บัญชี"ไม่เกิน {{$v.inputBank.bankNumber.$params.maxLength.max}} ตัวเลข</label>
                </div>
                <div class="form-group">
                  <label for="inputNameBank">
                    <span class="text-danger">*</span> ชื่อบัญชี
                  </label>
                  <input
                      for="inputNameBank"
                      v-model="inputBank.name"
                      @input="validateThai"
                      class="form-control"
                      :class="{ 'is-invalid': submitForm && $v.inputBank.name.$error }"
                      placeholder="กรุณากรอกชื่อบัญชี"
                  />
                  <label
                      v-if="submitForm && !$v.inputBank.name.required"
                      class="invalid-feedback"
                  >กรุณากรอกชื่อบัญชี</label>
                  <label
                      v-if="submitForm && !$v.inputBank.name.alpha"
                      class="invalid-feedback"
                  >กรุณากรอกตัวอักษร</label>
                </div>
                <div class="d-flex justify-content-center mt-4">
                  <b-button 
                    class="px-5" 
                    variant="secondary" 
                    @click="closeModal()"
                  >
                      ยกเลิก
                  </b-button>
                  <b-button 
                    class="px-5" 
                    variant="primary" 
                    @click="transectionBanking()"
                  >
                      ยืนยัน
                  </b-button>
                </div>
            </div>
        </b-modal>
  </div>
</template>

<script>
import BaseSelectBank from '@/components/BaseSelectBank';
import { 
  required, 
  alpha, 
  minLength,
  maxLength 
} from "vuelidate/lib/validators"
import validatePop from "@/plugins/validatePop.js"
import { showErrorModal } from "@/components/modalNotification.js";

export default {
    props: {
        modalShop: Object,
        editShopBank: Object,
        inputBank: Object,
    },
    components: {
        BaseSelectBank
    },
    data() {
        return {
            icon: {
                close: {
                    url: require("../../assets/icon/close.svg")
                }
            },
            submitForm: false
        }
    },
    validations: {
      inputBank: {
        selectBanking: { required },
        bankNumber: { 
          required, 
          minLength,
          maxLength,
        },
        name: { required },
      }
    },
    methods: {
        transectionBanking() {
          this.$refs.selectBanking.validateSelect();
          
          this.submitForm = true;
          
          this.$v.inputBank.$touch();
          if (this.$v.inputBank.$invalid) {
            return false
          }

          this.submitForm = false;

          const shopId = this.$route.params.Id
          const bodyParser = {
            shop_id: parseInt(shopId),
            account_bank: this.inputBank.selectBanking,
            account_id: this.inputBank.bankNumber,
            name: this.inputBank.name
          }
          const headers = {
            headers: {
                Token: localStorage.getItem("access_token")
            }
          }

          if(this.modalShop.type === 'adding') {
              this.addingBanking(shopId, bodyParser , headers);
          }else if (this.modalShop.type === 'editing') {
              this.editBanking(bodyParser , headers);
          }
        },
        editBanking(bodyParser , headers) {
          this.$http.put(this.$API_URL + `/shop/bank/${this.editShopBank.id}`, bodyParser, headers).then((res) => {
            let checkError = validatePop(res);
            if (!checkError.status) {
                if (checkError.notices == "token is expired") {
                    this.$router.push("/logout");
                }
                showErrorModal(checkError.msg);
                return false;
            }

            this.closeModal()
            return this.$emit("emitRefreshBank")
          })
        },
        addingBanking(shopId, bodyParser , headers) {
          this.$http.post(this.$API_URL + `/shop/bank`, bodyParser, headers).then((res) => {
            let checkError = validatePop(res);
            if (!checkError.status) {
                if (checkError.notices == "token is expired") {
                    this.$router.push("/logout");
                }
                showErrorModal(checkError.msg);
                return false;
            }
            this.closeModal()
            return this.$emit("emitRefreshBank")
          })
        },
        clearParamBank() {
            this.inputBank.selectBanking = ''
            this.inputBank.unmaskedValue = ''
            this.inputBank.bankNumber = ''
            this.inputBank.name = ''
        },
        validateThai(event) {
          const thaiRegex = /^[ก-๙]*$/
          if (!thaiRegex.test(event.target.value)) {
            event.target.value = this.inputBank.name
          } else {
            this.inputBank.name = event.target.value
          }
        },
        closeModal() {
            this.modalShop.BankDetail = !this.modalShop.BankDetail;
            this.clearParamBank()
        },
    },
}
</script>

<style>

</style>